<template lang="pug">
#footer
  .footer_menu.d-none.d-md-block.i_pt_10.i_pb_10
    .container.custom_container_md.flex_h.justify-content-between
      .left.flex_v
        .options
          ul
            li 客戶協助
            li(
              v-for="(customerService, index) in siteMap.CustomerServiceList",
              :key="index"
            )
              a(:href="customerService.URL", target="_blank") {{ customerService.Name }}
          ul
            li 熱門搜尋
            li
              ul.search_item(
                v-if="index % 3 == 0",
                v-for="(word, index) in hotKeyword.HotKeywordList"
              ) 
                |
                |
                |
                |
                |
                |
                |
                |
                |
                |
                |
                |
                |
                |
                li(
                  v-for="(word, sonIndex) in hotKeyword.HotKeywordList",
                  v-if="sonIndex >= index && sonIndex < index + 3"
                ) 
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  |
                  router-link(
                    v-if="word.HotKeywordProductJson == '-1'",
                    tag="a",
                    :to="{ name: 'Customize', params: { page: word.CustomizeJson } }"
                  ) {{ word.HotKeywordTitle }}
                  p(
                    v-else,
                    style="cursor: pointer",
                    @click="toProduct(word.HotKeywordProductJson)"
                  ) {{ word.HotKeywordTitle }}
          ul
            li 加入我們
            li
              a(
                href="https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1",
                target="_blank"
              ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
          ul
            li 友站連結
            li(v-for="(link, index) in siteMap.LinkList", :key="index")
              a(target="_blank", :href="link.URL") {{ link.Name }}
          ul
            li 網站導覽與聲明
            li
              router-link(tag="a", :to="{ name: 'Sitemap' }") 網站地圖
            li
              router-link(
                tag="a",
                :to="{ name: 'CustomerProtectionStatement' }"
              ) 客戶保護及聲明事項
          ul
            li
            li
              a(href="/customize/Trafficsafetyzone") 交通安全宣導專區
            li
              a(href="https://easyaccess.tmnewa.com.tw/", target="_blank") 友善服務網站
            li
              a(
                href="https://accessibility.moda.gov.tw/Applications/Detail?category=20260810114801",
                title="友善服務網站無障礙標章（另開新視窗）",
                target="_blank",
                rel="noopener noreferrer"
              )
                img.ccessibility(src="@/assets/img/icon/ccessibility.png", alt="友善服務網站通過AAA無障礙網頁檢測")
          ul
            li
            li
              img.twca(src="@/assets/img/icon/twisports.png")
            li
              a(
                href="https://ssl2.twca.com.tw/NCWebSSL/certinfo.htm?DNS=www.tmnewa.com.tw&SerialNumber=95584992868777842497808512746413626855&lang=zh",
                target="_blank"
              )
                img.twca(src="@/assets/img/icon/SMALL.png")
      .contact
        ul
          li 認識我們
          li
            router-link(tag="a", :to="{ name: 'AboutUsProfile' }") 公司簡介
          li
            router-link(tag="a", :to="{ name: 'AboutUsSocialResponsibility' }") 永續發展
          li
            router-link(tag="a", :to="{ name: 'AboutUsPublicInfo' }") 公開資訊
          li
            router-link(tag="a", :to="{ name: 'AboutUsGovernance' }") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li
            router-link(tag="a", :to="{ name: 'AboutUsNews' }") 最新消息
          li
            router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }") 商業合作
          li
            router-link(tag="a", :to="{ name: 'ShareholderServices' }") 股東專區
          li
            a(href="/customize/manager") 公平待客
  .footer_menu_mobile.container-fluid.d-md-none
    .container
      .row.i_pt_4
        .list_item(:class="{ expand: isExpandList[0] }")
          .title.d-flex.justify-content-between.align-items-center(
            @click="expand(0)"
          )
            h5.i_mt_1.i_mt_sm_0 客戶協助
            svg-icon.i_ml_2(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g"
            )
          ul.content
            li(
              v-for="(customerService, index) in siteMap.CustomerServiceList",
              :key="index"
            )
              a(:href="customerService.URL", target="_blank") {{ customerService.Name }}
        .list_item(:class="{ expand: isExpandList[4] }")
          .title.d-flex.justify-content-between.align-items-center(
            @click="expand(4)"
          )
            h5.i_mt_1.i_mt_sm_0 熱門搜尋
            svg-icon.i_ml_2(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g"
            )
          ul.content
            li(v-for="(word, sonIndex) in hotKeyword.HotKeywordList") 
              |
              |
              |
              |
              |
              |
              |
              |
              |
              |
              |
              |
              |
              |
              router-link(
                v-if="word.HotKeywordProductJson == '-1'",
                tag="a",
                :to="{ name: 'Customize', params: { page: word.CustomizeJson } }"
              ) {{ word.HotKeywordTitle }}
              p(
                v-else,
                style="cursor: pointer",
                @click="toProduct(word.HotKeywordProductJson)"
              ) {{ word.HotKeywordTitle }}

        .list_item(:class="{ expand: isExpandList[1] }")
          .title.d-flex.justify-content-between.align-items-center(
            @click="expand(1)"
          )
            h5.i_mt_1.i_mt_sm_0 網站導覽與聲明
            svg-icon.i_ml_2(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g"
            )
          ul.content
            li
              router-link(tag="a", :to="{ name: 'Sitemap' }") 網站地圖
            li
              router-link(
                tag="a",
                :to="{ name: 'CustomerProtectionStatement' }"
              ) 客戶保護及聲明事項
            li
              a(href="/customize/Trafficsafetyzone") 交通安全宣導專區
            li
              a(href="https://easyaccess.tmnewa.com.tw/", target="_blank") 友善服務網站
            li
              a(
                href="https://accessibility.moda.gov.tw/Applications/Detail?category=20260810114801",
                title="友善服務網站無障礙標章（另開新視窗）",
                target="_blank",
                rel="noopener noreferrer"
              )
                img.ccessibility(src="@/assets/img/icon/ccessibility.png", alt="友善服務網站通過AAA無障礙網頁檢測")
            li
              img.twca(src="@/assets/img/icon/twisports.png")
            li
              a(
                href="https://ssl2.twca.com.tw/NCWebSSL/certinfo.htm?DNS=www.tmnewa.com.tw&SerialNumber=95584992868777842497808512746413626855&lang=zh",
                target="_blank"
              )
                img.twca(src="@/assets/img/icon/SMALL.png")
        .list_item(:class="{ expand: isExpandList[2] }")
          .title.d-flex.justify-content-between.align-items-center(
            @click="expand(2)"
          )
            h5.i_mt_1.i_mt_sm_0 加入我們
            svg-icon.i_ml_2(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g"
            )
          ul.content
            li
              a(
                href="https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1",
                target="_blank"
              ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
        .list_item(:class="{ expand: isExpandList[3] }")
          .title.d-flex.justify-content-between.align-items-center(
            @click="expand(3)"
          )
            h5.i_mt_1.i_mt_sm_0 友站連結
            svg-icon.i_ml_2(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g"
            )
          ul.content
            li(v-for="(link, index) in siteMap.LinkList", :key="index")
              a(target="_blank", :href="link.URL") {{ link.Name }}

        .list_item(:class="{ expand: isExpandList[5] }")
          .title.d-flex.justify-content-between.align-items-center(
            @click="expand(5)"
          )
            h5.i_mt_1.i_mt_sm_0 關於我們
            svg-icon.i_ml_2(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g"
            )
          ul.content
            li
              router-link(tag="a", :to="{ name: 'AboutUsProfile' }") 公司簡介
            li
              router-link(
                tag="a",
                :to="{ name: 'AboutUsSocialResponsibility' }"
              ) 永續發展
            li
              router-link(tag="a", :to="{ name: 'AboutUsPublicInfo' }") 公開資訊
            li
              router-link(tag="a", :to="{ name: 'AboutUsGovernance' }") 公司治理
            li
              a(href="/customize/Stewardship") 盡職治理
            li
              router-link(tag="a", :to="{ name: 'AboutUsNews' }") 最新消息
            li
              router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }") 商業合作
            li
              router-link(tag="a", :to="{ name: 'ShareholderServices' }") 股東專區
            li
              a(href="/customize/manager") 公平待客
  footer(ref="footer")
    .container-fluid
      .row.justify-content-center.align-items-center.contact_info
        .d-md-flex.justify-content-center.col-xl-auto.col-lg-12
          p 客服暨申訴專線：0800-050-119
          p 地址：104 台灣台北市中山區南京東路三段130號8-13樓
      .row.justify-content-center.align-items-start.align-items-md-center.copy_right
        .d-flex.justify-content-between.align-items-md-center.align-items-start.col-xl-auto.col-lg-12
          .copy_right_img
            img(src="@/assets/img/media/footer-corp.png", alt="東京海上集團")
          .copy_right_text
            div
              img(
                src="@/assets/img/media/footer-slogan.png",
                alt="To Be a Good Company"
              )
            div
              p Copyright ©2023 新安東京海上產物保險(股)公司
              p All rights reserved
</template>

<script>
import { getSiteMap, getHotKeyword } from "@/json/menu";

export default {
  name: "CustomFooter",
  data() {
    return {
      isExpandList: [false, false, false, false, false, false],
      siteMap: {},
      hotKeyword: {},
    };
  },
  created() {
    this.getSiteMap();
    this.getHotKeyword();
  },
  methods: {
    getSiteMap() {
      getSiteMap().then((response) => {
        this.siteMap = response.data;
      });
    },
    getHotKeyword() {
      getHotKeyword().then((response) => {
        this.hotKeyword = response.data;
      });
    },
    expand(index) {
      this.isExpandList.splice(index, 1, !this.isExpandList[index]);
    },
    toProduct(productJson) {
      this.$router.push({
        name: "ProductIntro",
        params: {
          type: productJson,
        },
      });
      if ("ProductIntro" == this.$route.name) {
        this.$emit("footerProductClick");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/footer";
.fa-facebook-square,
.fa-youtube {
  color: $color_black_text;
}
</style>
